import React, { useCallback } from "react";
import { Alert, Anchor } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons";
import { useTabNavigate } from "../../hooks/useTabNavigate";
import { buildTabLocation } from "../../utils/tabNavigation";
import { getMcaApprovingBannerTitle } from "./mcaApprovalLabels";

const isModifiedClick = (event) =>
  event.ctrlKey ||
  event.metaKey ||
  event.shiftKey ||
  event.altKey ||
  event.button === 1;

const McaPendingBanner = ({
  requestCode,
  requestId,
  action,
  processName,
  status,
}) => {
  const tabNav = useTabNavigate();
  const title =
    action && status
      ? getMcaApprovingBannerTitle(action, status)
      : "Pending approval request";

  const pathname = requestId ? `/mca/requests/${requestId}` : null;
  const href = pathname ? buildTabLocation(pathname) : undefined;
  const tabLabel = requestCode ? `MCA - ${requestCode}` : "MCA Request";

  const handleViewRequest = useCallback(
    (e) => {
      if (!pathname) return;
      if (isModifiedClick(e)) return;
      if (!tabNav.enabled) return;
      e.preventDefault();
      tabNav.open({ pathname, label: tabLabel });
    },
    [pathname, tabLabel, tabNav],
  );

  return (
    <Alert
      icon={<IconAlertCircle size={16} />}
      color={status === "REJECTED" ? "red" : "orange"}
      mb="md"
      title={title}
    >
      This entity has an active MCA change request
      {requestCode ? ` (${requestCode})` : ""}.
      {processName ? ` Process: ${processName}.` : ""}
      {requestId && (
        <>
          {" "}
          <Anchor href={href} onClick={handleViewRequest}>
            View request
          </Anchor>
        </>
      )}
    </Alert>
  );
};

export default McaPendingBanner;
